import React, { useEffect, useState, useRef } from 'react';
import ModalRedirectPayments from './redirectPaymentsComponent';
import { AdminService } from 'services';
import { PaymentProvider } from 'utils/enums/PaymentProvider';

export default function RedirectPayments(props) {
    const { showCsDownModal, setShowCsDownModal } = props;
    const [trafficValue, setTrafficValue] = useState('');

    const handleClose = () => {
        setShowCsDownModal(false);
    };
    const submitHandler = () => {
        AdminService.TrafficSwitchCheckoutHf({
            from: PaymentProvider.CARDSTREAM,
            to: PaymentProvider.CHECKOUT_HF,
            percentage: trafficValue
        });
        setShowCsDownModal(false);
    };
    return (
        <ModalRedirectPayments
            showCsDownModal={showCsDownModal}
            trafficValue={trafficValue}
            setTrafficValue={setTrafficValue}
            handleClose={handleClose}
            submitHandler={submitHandler}
        ></ModalRedirectPayments>
    );
}
